import axios from 'axios'
import { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import urlSearchParams from '../../components/urlSearchParams'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { ProductContext } from '../../context api/Product/ProductContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { checkCancelToken, error, ROUTES, success, getNewToken } from '../../shared/constants'

export const useProduct = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const [product, setProduct] = useState(false)
  const { addNewProduct, editNewProduct, deleteNewProduct, getNewProducts } = useContext(ProductContext)
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const [paginate, setPaginate] = useState(false)
  const [allSecondaryVariant, setSecondaryVariant] = useState(false)
  const [cancelToken, setCancelToken] = useState()
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pdfCsvData, setPdfCsvData] = useState(false)

  useEffect(() => {
    if (cancelToken) {
      setLoading(true)
    }
  }, [cancelToken])

  const getAllProducts = (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_PRODUCTS(urlSearchParams(dto)), {
        ...header,
        cancelToken: getNewToken(cancelToken, setCancelToken),
      })
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setPaginate(data.paginate)
        getNewProducts(data.data, data.totalPage)
        setPdfCsvData({ headings: data.headings, headingValues: data.headingValues })
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getProduct = (dto) => {
    setLoading(true)
    axios
      .post(API.GET_PRODUCT, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setProduct(data.product)
        // setProducts(data.product)
        // getNewProducts(data.product, data.totalPage)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getAllSecondaryVariant = (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_SECONDARY_VARIANT(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setSecondaryVariant(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const addProduct = async (data) => {
    setLoading(true)
    axios
      .post(API.ADD_PRODUCT, data, header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Product Added Successfully', success)
        addNewProduct(data.product)
      })
      .catch((err) => {
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const editProduct = async (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_PRODUCT, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Product Updated Successfully', success)
        // editNewProduct(data.product)
        history.push(ROUTES.PRODUCTS)
        getAllProducts()
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const deleteProduct = async (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_PRODUCT, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Product Deleted Successfully', success)
        // handleNext()
        deleteNewProduct(dto.productId)
        setSelected([])
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const deleteManyProduct = async (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_MANY_PRODUCT, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.productId.length} Product Deleted Successfully`, success)

        dto.productId.map((item) => deleteNewProduct(item))
        setSelected([])
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        bulkUploadPopup(data, addNewProduct)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getPdfCsvData = async (dto = {}) => {
    setDownloadLoading(true)
    dto = { ...dto, download: 1 }
    axios
      .get(API.GET_ALL_PRODUCTS(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setDownloadLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPdfCsvData(data)
      })
      .catch((err) => {
        setDownloadLoading(false)
        if (err.response) {
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  return {
    getAllProducts,
    deleteProduct,
    getProduct,
    product,
    addProduct,
    editProduct,
    deleteManyProduct,
    BulkUpload,
    loading,
    paginate,
    getAllSecondaryVariant,
    allSecondaryVariant,
    getPdfCsvData,
    pdfCsvData,
    downloadLoading,
  }
}
